import { BrowserRouter, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import Routes from "./routes";
import Layout from "./components/Layout";
import "react-toastify/dist/ReactToastify.css";

import AuthProvider from './contexts/authContext';

// função para enviar eventos de pageview ao GTM

const helmetContext = {};
const useGTMPageView = () =>{
  const location = useLocation();

  useEffect(() => {
    // inicializa o dataLayer caso não exista
    window.dataLayer = window.dataLayer || [];
    // envia o evento de visualização de página
    window.dataLayer.push({
      event: "pageview",
      page_path: location.pathname,
      page_title: document.title,
    });
  }, [location]);
}

export default function App(){
  return(
    <HelmetProvider context={helmetContext}>
      <BrowserRouter 
        future={{
          v7_startTransition: true, // ativa o modo de transição do React Router v7
          v7_relativeSplatPath: true, // ativa o caminho relativo do React Router v7
        }}
      >
        <AuthProvider>
          <GTMWrapper/>
          <Layout>
            <Routes/>
          </Layout>
        </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

const GTMWrapper = () => {
  useGTMPageView();

  useEffect(() => {
    // adiciona o script do GTM ao carregar a aplicação
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/ns.html?id=GTM-PB3RPKRH";
    document.head.appendChild(script);

    return () => {
      // limpa o script ao desmontar
      document.head.removeChild(script);
    };
  }, []);

  return null;
};